import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { PortfolioRoutes } from '../../../routes';

export const PortfolioLayout = () => <SwitchRoute routes={PortfolioRoutes} />;
